export const REMOTE_AVATAR_TEMPLATE = "#remote-avatar";

export function shouldSuppressAvatarNetworking(config) {
  return !!config?.invisibleAvatar?.enabled;
}

export function shouldSpawnNetworkedAvatar(config) {
  return !!config?.avatarNetworking?.enabled && !shouldSuppressAvatarNetworking(config);
}

function isRemoteAvatarEntityData(entityData) {
  return entityData?.template === REMOTE_AVATAR_TEMPLATE;
}

export function filterRemoteAvatarNAFMessage(message) {
  if (!message?.data) {
    return message;
  }

  if (message.dataType === "um" && Array.isArray(message.data.d)) {
    const filteredData = message.data.d.filter(entityData => !isRemoteAvatarEntityData(entityData));

    if (filteredData.length === 0) {
      return null;
    }

    if (filteredData.length === message.data.d.length) {
      return message;
    }

    return {
      ...message,
      data: {
        ...message.data,
        d: filteredData
      }
    };
  }

  if (isRemoteAvatarEntityData(message.data)) {
    return null;
  }

  return message;
}

function getNetworkedData(entity) {
  return entity?.components?.networked?.data || entity?.getAttribute?.("networked") || {};
}

export function removeRemoteAvatarEntities(naf = typeof NAF !== "undefined" ? NAF : null) {
  const entities = naf?.entities?.entities;
  const removeEntity = naf?.entities?.removeEntity;

  if (!entities || typeof removeEntity !== "function") {
    return;
  }

  const localClientId = naf?.clientId;

  for (const networkId of Object.keys(entities)) {
    const entity = entities[networkId];
    const networkedData = getNetworkedData(entity);
    const isLocalAvatar =
      entity?.id === "avatar-rig" || networkedData.creator === localClientId || networkedData.owner === localClientId;

    if (networkedData.template === REMOTE_AVATAR_TEMPLATE && !isLocalAvatar) {
      removeEntity.call(naf.entities, networkId);
    }
  }
}

export function removeLocalNetworkedAvatar(
  avatarRig = typeof document !== "undefined" ? document.getElementById("avatar-rig") : null
) {
  avatarRig?.removeAttribute?.("networked");
  avatarRig?.removeAttribute?.("networked-avatar");
}
